import { render, staticRenderFns } from "./IconDiskette.vue?vue&type=template&id=1d403039&"
import script from "./IconDiskette.vue?vue&type=script&lang=js&"
export * from "./IconDiskette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports